import React, { useMemo } from 'react';
import useAppStore from '../../store/useAppStore.js';
import Button from '../common/Button.js';

const UserTable = ({ onCreateUser, onEditUser, onDeactivateUser, onDeleteUser }) => {
  const { admin } = useAppStore((state) => ({
    admin: state.admin
  }));

  const branchMap = useMemo(
    () => Object.fromEntries((admin.branches || []).map((branch) => [branch.id, branch.name])),
    [admin.branches]
  );

  return (
    <div className="rounded-3xl border border-gray-200 bg-white p-6 shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div>
          <h2 className="text-2xl font-semibold text-slate-900">Team members</h2>
          <p className="mt-1 text-sm text-gray-500">Manage users across branches.</p>
        </div>
        <Button onClick={onCreateUser}>
          + New User
        </Button>
      </div>

      <div className="overflow-auto h-[400px]">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50 text-left text-gray-600">
            <tr>
              <th className="px-4 py-3 font-medium">Name</th>
              <th className="px-4 py-3 font-medium">Email</th>
              <th className="px-4 py-3 font-medium">Role</th>
              <th className="px-4 py-3 font-medium">Branch</th>
              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3 font-medium">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {(admin.users || []).map((user) => (
              <tr key={user.id} className="hover:bg-gray-50">
                <td className="px-4 py-4 font-medium text-slate-900">{user.name || user.username}</td>
                <td className="px-4 py-4 text-gray-600">{user.email || '—'}</td>
                <td className="px-4 py-4 text-gray-600">{user.role}</td>
                <td className="px-4 py-4 text-gray-600">{branchMap[user.branchId] || 'Unassigned'}</td>
                <td className="px-4 py-4">
                  <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${
                    user.active ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-600'
                  }`}>
                    {user.active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="px-4 py-4 space-x-2 flex">
                  <Button
                    size="small"
                    variant="outline"
                    onClick={() => onEditUser(user)}
                  >
                    Edit
                  </Button>
                  <Button
                    size="small"
                    variant={user.active ? 'danger' : 'secondary'}
                    onClick={() => onDeactivateUser(user.id)}
                  >
                    {user.active ? 'Deactivate' : 'Activate'}
                  </Button>
                  <Button
                    size="small"
                    variant="danger"
                    onClick={() => onDeleteUser(user.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
            {((admin.users || []).length === 0) && (
              <tr>
                <td colSpan="6" className="px-4 py-8 text-center text-gray-500">
                  {admin.usersLoading ? 'Loading users...' : 'No users available.'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserTable;